import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { SSOCallback } from './components/SSOCallback';
import { PermissionProvider } from './contexts/PermissionContext';
import './styles/index.css';
import { clerkPubKey } from './lib/clerk';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey}>
      <PermissionProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/sso-callback" element={<SSOCallback />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </BrowserRouter>
      </PermissionProvider>
    </ClerkProvider>
  </React.StrictMode>
);
